module.exports = __webpack_public_path__ + "media/content-creator/tech-2-120888a5.png";